import { Button } from "@/components/ui/button";
import { MapPin, Phone, Clock, Navigation } from "lucide-react";

const LocationSection = () => {
  return (
    <section className="py-24 bg-background">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="font-heading text-3xl sm:text-4xl md:text-5xl font-bold text-brown mb-4">
            Discover The Perfect <span className="text-river">River Escape</span>
          </h2>
          <p className="text-lg text-muted-foreground">
            Conveniently located between Austin and San Antonio in the heart of Texas Hill Country.
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 max-w-6xl mx-auto">
          {/* Map */}
          <div className="rounded-2xl overflow-hidden shadow-elevated border border-border h-[400px] lg:h-auto">
            <iframe
              src="https://maps.google.com/maps?q=2769+Sherrill+Rd,+Kingsbury,+TX+78638&t=&z=14&ie=UTF8&iwloc=&output=embed"
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: "400px" }}
              allowFullScreen
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Son's Blue River Camp Location - 2769 Sherrill Rd, Kingsbury, TX"
            />
          </div>

          {/* Info */}
          <div className="space-y-8">
            <div className="bg-card rounded-2xl p-8 shadow-soft border border-border">
              <h3 className="font-heading text-2xl font-semibold text-foreground mb-6">
                Son's Blue River Camp
              </h3>

              <div className="space-y-4">
                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-river/10 flex items-center justify-center flex-shrink-0">
                    <MapPin className="h-5 w-5 text-river" />
                  </div>
                  <div>
                    <p className="font-semibold text-foreground">Address</p>
                    <p className="text-muted-foreground">2769 Sherrill Rd<br />Kingsbury, TX 78638</p>
                    <p className="text-sm text-muted-foreground mt-1">(Near Fentress)</p>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-river/10 flex items-center justify-center flex-shrink-0">
                    <Phone className="h-5 w-5 text-river" />
                  </div>
                  <div>
                    <p className="font-semibold text-foreground">Phone</p>
                    <a href="tel:+18775777667" className="text-river hover:underline">(877) 577-7667</a>
                  </div>
                </div>

                <div className="flex items-start gap-4">
                  <div className="w-10 h-10 rounded-full bg-river/10 flex items-center justify-center flex-shrink-0">
                    <Clock className="h-5 w-5 text-river" />
                  </div>
                  <div>
                    <p className="font-semibold text-foreground">Hours</p>
                    <p className="text-muted-foreground">Day Rentals: 10:30 AM - 6:30 PM</p>
                    <p className="text-muted-foreground">Open everyday in Summer, most days in Fall & Spring, Closed Dec.-Feb.</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Distance Cards */}
            <div className="grid grid-cols-3 gap-4">
              <div className="bg-sand rounded-xl p-4 text-center">
                <p className="font-heading text-2xl font-bold text-river">45</p>
                <p className="text-sm text-foreground">min from Austin</p>
              </div>
              <div className="bg-sand rounded-xl p-4 text-center">
                <p className="font-heading text-2xl font-bold text-river">1</p>
                <p className="text-sm text-foreground">hr from San Antonio</p>
              </div>
              <div className="bg-sand rounded-xl p-4 text-center">
                <p className="font-heading text-2xl font-bold text-river">2.5</p>
                <p className="text-sm text-foreground">hrs from Houston</p>
              </div>
            </div>

            <Button variant="river" size="lg" className="w-full" asChild>
              <a 
                href="https://www.google.com/maps/dir//2769+Sherrill+Rd,+Kingsbury,+TX+78638" 
                target="_blank" 
                rel="noopener noreferrer"
                className="flex items-center justify-center gap-2"
              >
                <Navigation className="h-5 w-5" />
                Get Directions
              </a>
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LocationSection;
